module.exports = __webpack_public_path__ + "static/media/group-quote-small-placeholder.6e2233e7.webp";